export default {
  en: {
    'DEFAULT_REPORT_NAME': 'Untitled Report',
    'SAVE_TT': 'Save a new report',
    'UPDATE_REPORT_TT': 'Update saved report',
    'SAVE_AS_TT': 'Save a new report with the same settings',
    'DELETE_TT': 'Delete this saved report',
    'DELETE_MESSAGE': 'Are you sure you want to delete this saved report?',
  }
};